import React from 'react'
import BasicButton from './buttons/BasicButton'
import { Link } from 'react-router-dom'
import ROUTES from '../../application/utils/Routes'
import PageTitle from './PageTitle'

function AdminsTopBar() {
    return (
        <div className="flex justify-between">
            
            <PageTitle title="Admins"/>

            <div>
                <Link to={ROUTES.ADDADMINS}>
                    <BasicButton text="New Admin" />
                </Link>
            </div>

        </div>
    )
}

export default AdminsTopBar